const MOBILE_MAX_WIDTH_PX = 768;

export function getInitialJobIndexFiltersCollapsed(): boolean {
  if (
    typeof window !== 'undefined' &&
    window.innerWidth <= MOBILE_MAX_WIDTH_PX
  ) {
    return true;
  }
  return localStorage.getItem('jobIndexFiltersCollapsed') === 'true';
}
